/* angular:styles/component:css;5013333d46010dbf;/builds/service-planning/cloud/frontend/src/app/shared/components/tooltip/tooltip-outlet.component.ts */
tds-tooltip {
  z-index: 1001;
}
/*# sourceMappingURL=tooltip-outlet.component.css.map */
